import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import Card from "@mui/material/Card";
import { useEffect, useState } from "react";
import MDButton from "../../../../components/MDButton";
import DataTableDataStaffs from "./data";
import Modal from '@mui/material/Modal';
import InsertUserComponent from "../../users/insert";
import { useNavigate } from "react-router-dom";
import { DialogShower, SnackShower, TableShower } from "../../../../components/Utils/Tools";
import * as Yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
import { modalStyle } from "../../../../components/Utils/ModalStyle";
import { TextField, Tooltip } from "@mui/material";
import Switch from "@mui/material/Switch";
import LoadingOverlay from 'react-loading-overlay';
import UserService from "../../../../services/user.service";
import MDEditor from "../../../../components/MDEditor";


function Staffs() {


    const title = "New Staff"
    const defaultInputValues = { newPassword: '', passwordConfirmation: '' }
    const [values, setValues] = useState(defaultInputValues);
    const [isValid, setIsValid] = useState(false);
    const validationSchema = Yup.object().shape({
        newPassword: Yup.string()
            .required('New Password is required')
            .min(6, 'New Password must be at least 6 characters'),
        passwordConfirmation: Yup.string()
            .oneOf([Yup.ref('newPassword'), null], 'Passwords must match'),
    });
    const { register, handleSubmit, formState: { errors } } =
        useForm({ mode: "all", resolver: yupResolver(validationSchema) });

    const [activeLoading, setActiveLoading] = useState(false);
    const [showModalChangePassword, setShowModalChangePassword] = useState(false);
    const [showModalChangeUnit, setShowModalChangeUnit] = useState(false);
    const [selectedUser, setSelectedUser] = useState({});
    const [snackBarSetting, setSnackBarSetting] = useState({ type: "error", error_message: "", show: false });
    const [selectedRecipients, setSelectedRecipients] = useState({});
    const [showBulkEmailModal, setShowBulkEmailModal] = useState(false);
    const [bulkEmailSubject, setBulkEmailSubject] = useState("");
    const [bulkEmailBody, setBulkEmailBody] = useState("");
    const [selectedForOtherLimit, setSelectedForOtherLimit] = useState(0);
    const [selectedForOtherUnlimited, setSelectedForOtherUnlimited] = useState(false);

    const [userInsertSetting, setUserInsertSetting] = useState({ show: false, showBulk: false, title: "Main Building" });
    const handleChange = (value) => {
        setValues(value);
        setIsValid(validationSchema.isValidSync(values));
    };
    setTimeout(function () {
        setIsValid(validationSchema.isValidSync(values));
    }, 1000);

    const onClickSaveData = (e) => {
        console.log("onClickSaveData");

        e.preventDefault();
        if (isValid) {
            setActiveLoading(true);
            values["user"] = selectedUser.id
            UserService.ChangePasswordAdminMode(values)
                .then((e) => {
                    setSnackBarSetting({ ...snackBarSetting, show: true, type: "info", error_message: "" })
                    window.location.reload(true);
                    setActiveLoading(false);
                }).catch((err) => {
                    setSnackBarSetting({ ...snackBarSetting, show: true, type: "error", error_message: err.response.data.status })
                    setActiveLoading(false);
                });
        }

    }


    const onClickSaveDataUnits = (e) => {
        console.log("onClickSaveDataUnits");

        e.preventDefault();
        const createdValues = {
            'user': selectedUser.id,
            'unit': selectedUnit,
            'firstName': selectedFirstName,
            'lastName': selectedLastName,
            'email': selectedEmail,
            'client': selectedUser.client,
            'for_other_daily_amenity_limit': selectedForOtherUnlimited ? null : String(selectedForOtherLimit || 0),
        }

        setActiveLoading(true);
        UserService.updateUser(selectedUser.id, createdValues)
            .then(() => {
                setActiveLoading(false);
                setSnackBarSetting({ ...snackBarSetting, show: true, type: "info", error_message: "" })
                window.location.reload(true);
            }).catch((err) => {
                setActiveLoading(false);
                setSnackBarSetting({ ...snackBarSetting, show: true, type: "error", error_message: err.response.data.status })

            });

    }



    const onClickResendEmailItem = (elem) => {
        let id = elem.target.id;
        setActiveLoading(true);
        UserService.resendConfirmEmail(id)
            .then((e) => {
                setSnackBarSetting({ ...snackBarSetting, show: true, type: "info", error_message: "" })
                // window.location.reload(true);
                setActiveLoading(false);
                setDialogSetting({ ...dialogSetting, show: false });
            }).catch((err) => {
                setSnackBarSetting({ ...snackBarSetting, show: true, type: "error", error_message: err.response.data.status });
                setActiveLoading(false);
                setDialogSetting({ ...dialogSetting, show: false });
            });
    }
    const onClickDisableItem = (elem) => {
        let id = elem.target.id;
        setActiveLoading(true);
        UserService.disableUser(id)
            .then((e) => {
                setSnackBarSetting({ ...snackBarSetting, show: true, type: "info", error_message: "" })
                // window.location.reload(true);
                setActiveLoading(false);
                setDialogSetting({ ...dialogSetting, show: false });
                window.location.reload(true);
            }).catch((err) => {
                setSnackBarSetting({ ...snackBarSetting, show: true, type: "error", error_message: err.response.data.status });
                setActiveLoading(false);
                setDialogSetting({ ...dialogSetting, show: false });
            });
    }
    const onClickRemoveItem = (elem) => {
        let id = elem.target.id;
        setActiveLoading(true);
        UserService.deleteUser(id)
            .then((e) => {
                setSnackBarSetting({ ...snackBarSetting, show: true, type: "info", error_message: "" })

                setActiveLoading(false);
                setDialogSetting({ ...dialogSetting, show: false });
                window.location.reload(true);
            }).catch((err) => {
                setSnackBarSetting({ ...snackBarSetting, show: true, type: "error", error_message: err.response.data.status });
                setActiveLoading(false);
                setDialogSetting({ ...dialogSetting, show: false });
            });
    }

    const [dialogSetting, setDialogSetting] = useState({ show: false, onClickDone: onClickRemoveItem, id: "" });

    const navigate = useNavigate();

    const onClickRow = (elem) => {
        let actionToDo = elem.target.getAttribute("action");
        let rowName = elem.target.getAttribute("rowname");
        let client = elem.target.getAttribute("client");
        let rowId = elem.target.id;
        setSelectedUser({ ...selectedUser, id: rowId, name: rowName, client: client });
        console.log(actionToDo + rowName + rowId)
        switch (actionToDo) {
            case "change_password":
                setShowModalChangePassword(true);
                break;
            case "edit":
                setShowModalChangeUnit(true);
                getUserData(rowId);
                break;
            case "book_amenity":

                navigate("/amenities?userid=" + rowId);
                break;
            case "delete":
                setDialogSetting({ ...dialogSetting, title: "Delete", show: true, id: rowId, onClickDone: onClickRemoveItem })
                break;
            case "disable":
                setDialogSetting({ ...dialogSetting, title: "Disable/Enable", show: true, id: rowId, onClickDone: onClickDisableItem })
                break;
            case "resend_confirm":
                setDialogSetting({ ...dialogSetting, title: "Resend Confirmation Email", show: true, id: rowId, onClickDone: onClickResendEmailItem })
                break;
        }
    }
    const onClickNew = (e) => {
        console.log("onClickNew");
        // setShowModal(true);

        setUserInsertSetting({
            ...userInsertSetting,
            show: true,
            type: "staff"
        });
    }

    const selectedRecipientCount = Object.keys(selectedRecipients).length;
    const selectedRecipientEmails = Object.values(selectedRecipients)
        .map(({ email }) => email)
        .filter(Boolean);
    const selectedRecipientPreview = selectedRecipientEmails.length > 3
        ? `${selectedRecipientEmails.slice(0, 3).join(", ")} ...`
        : selectedRecipientEmails.join(", ");
    const selectedRecipientTooltip = selectedRecipientEmails.join("\n");
    const toggleRecipient = (recipient) => {
        setSelectedRecipients((current) => {
            const next = { ...current };
            if (next[recipient.id]) {
                delete next[recipient.id];
            } else {
                next[recipient.id] = recipient;
            }
            return next;
        });
    };
    const sendBulkEmail = () => {
        const textBody = bulkEmailBody.replace(/<[^>]+>/g, "").replace(/&nbsp;/g, " ").trim();
        if (selectedRecipientCount === 0 || !bulkEmailSubject.trim() || !textBody) {
            setSnackBarSetting({ ...snackBarSetting, show: true, type: "error", error_message: "Please select staff and enter subject and body." });
            return;
        }
        setActiveLoading(true);
        UserService.sendBulkEmail(Object.keys(selectedRecipients).map((id) => Number(id)), bulkEmailSubject.trim(), bulkEmailBody)
            .then(() => {
                setActiveLoading(false);
                setSelectedRecipients({});
                setBulkEmailSubject("");
                setBulkEmailBody("");
                setShowBulkEmailModal(false);
                setSnackBarSetting({ ...snackBarSetting, show: true, type: "info", error_message: "" });
            })
            .catch((err) => {
                setActiveLoading(false);
                setSnackBarSetting({
                    ...snackBarSetting,
                    show: true,
                    type: "error",
                    error_message: err.response?.data?.status || "Email could not be sent",
                });
            });
    };
    const renderBulkEmailButton = () => {
        if (selectedRecipientCount === 0) return null;

        return (
            <MDButton
                variant="gradient"
                color="info"
                size="small"
                onClick={() => setShowBulkEmailModal(true)}
            >
                Email Selected ({selectedRecipientCount})
            </MDButton>
        );
    };


    const [tableSetting, setTableSetting] = useState({
        data: DataTableDataStaffs,
        progressChanger: setActiveLoading,
        showButton: true,
        buttonText: title,
        buttonClick: onClickNew,
        onClickRow: onClickRow
    });



    const renderChangePasswordModel = () => {
        return <Modal open={showModalChangePassword} color={"warning"}
            onClose={(e) => { setShowModalChangePassword(false) }}>
            <MDBox sx={modalStyle}>
                <Card id="basic-info" sx={{ overflow: "visible" }}>
                    <MDBox p={3} pb={2}>
                        <MDTypography variant="h6">Change Password ({selectedUser.name})</MDTypography>
                    </MDBox>
                    <MDBox component="form" pb={3} >
                        <Grid container >
                            <Grid container spacing={2} pt={2} px={2} xs={12} md={12}   >
                                <Grid item xs={12} md={12}>
                                    <TextField
                                        required fullWidth
                                        type="password" label="New Password" name="newPassword"
                                        error={!!errors.newPassword}
                                        helperText={errors.newPassword?.message}
                                        value={values.newPassword}
                                        {...register("newPassword")}
                                        onChange={(event) =>
                                            handleChange({ ...values, newPassword: event.target.value })}
                                    />
                                </Grid>
                                <Grid item xs={12} md={12}>
                                    <TextField
                                        required fullWidth
                                        type="password" label="Confirm Password" name="passwordConfirmation"
                                        error={!!errors.passwordConfirmation}
                                        helperText={errors.passwordConfirmation?.message}
                                        value={values.passwordConfirmation}
                                        {...register("passwordConfirmation")}
                                        onChange={(event) =>
                                            handleChange({ ...values, passwordConfirmation: event.target.value })}
                                    />
                                </Grid>
                                <Grid item xs={12} md={12}>
                                    <MDButton color={"info"} size={"large"} sx={{ width: '50%' }}
                                        disabled={!isValid} onClick={onClickSaveData}  >Save Data</MDButton>
                                </Grid>

                            </Grid>
                        </Grid>
                    </MDBox>
                </Card>
            </MDBox>
        </Modal>
    }



    const [selectedUnit, setSelectedUnit] = useState("")
    const [selectedFirstName, setSelectedFirstName] = useState("")
    const [selectedLastName, setSelectedLastName] = useState("")
    const [selectedEmail, setSelectedEmail] = useState("")


    const getUserData = (userId) => {
        UserService.getUser(userId)
            .then((result) => {
                setSelectedFirstName(result.data["first_name"]);
                setSelectedLastName(result.data["last_name"]);
                setSelectedEmail(result.data["email"]);
                const limit = result.data["for_other_daily_amenity_limit"];
                setSelectedForOtherUnlimited(limit === null || limit === undefined);
                setSelectedForOtherLimit(limit === null || limit === undefined ? 0 : limit);
            }).catch((reason) => {
                alert(reason)
                setSelectedUnit("");
                setSelectedFirstName("");
                setSelectedLastName("");
                setSelectedEmail("");
            });
    }


    const renderChangeUnits = () => {
        return <Modal open={showModalChangeUnit} color={"warning"}
            onClose={(e) => { setShowModalChangeUnit(false) }}>
            <MDBox sx={modalStyle}>
                <Card id="basic-info" sx={{ overflow: "visible" }}>
                    <MDBox p={3} pb={2}>
                        <MDTypography variant="h6">Edit User ({selectedUser.name})</MDTypography>
                    </MDBox>
                    <MDBox component="form" pb={3} >
                        <Grid container >
                            <Grid container spacing={2} pt={2} px={2} xs={12} md={12}   >
                                <Grid item xs={12} md={6}>
                                    <TextField
                                        required fullWidth
                                        value={selectedFirstName}
                                        type="text" label="FirstName" name="firstName"
                                        onChange={(event) =>
                                            setSelectedFirstName(event.target.value)}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <TextField
                                        required fullWidth
                                        value={selectedLastName}
                                        type="text" label="LastName" name="lastName"
                                        onChange={(event) =>
                                            setSelectedLastName(event.target.value)}
                                    />
                                </Grid>
                                <Grid item xs={12} md={12}>
                                    <TextField
                                        fullWidth
                                        value={selectedEmail}
                                        type="text" label="Email" name="email"
                                        onChange={(event) =>
                                            setSelectedEmail(event.target.value)}
                                    />
                                </Grid>
                                <Grid item xs={12} md={12}>
                                    <TextField
                                        fullWidth
                                        type="text" label="Unit Name" name="unit"
                                        value={selectedUnit}
                                        placeholder={"If you want change unit"}
                                        onChange={(event) =>
                                            setSelectedUnit(event.target.value)}
                                    />
                                </Grid>
                                <Grid item xs={12} md={12}>
                                    <MDBox display="flex" alignItems="center" mb={1}>
                                        <Switch
                                            checked={selectedForOtherUnlimited}
                                            onChange={(event, checked) => {
                                                setSelectedForOtherUnlimited(checked);
                                                if (checked) setSelectedForOtherLimit(0);
                                            }}
                                        />
                                        <MDTypography variant="button" fontWeight="regular" color="text">
                                            Unlimited
                                        </MDTypography>
                                    </MDBox>
                                    <TextField
                                        fullWidth
                                        type="number"
                                        label="Daily booking limit per amenity"
                                        value={selectedForOtherLimit}
                                        disabled={selectedForOtherUnlimited}
                                        inputProps={{ min: 0 }}
                                        helperText="How many bookings this staff/admin can make for others per amenity per day. Select Unlimited for no limit."
                                        onChange={(event) => setSelectedForOtherLimit(event.target.value)}
                                    />
                                </Grid>
                                <Grid item xs={12} md={12}>
                                    <MDButton color={"info"} size={"large"} sx={{ width: '50%' }}
                                        onClick={onClickSaveDataUnits} >Save Data</MDButton>
                                </Grid>

                            </Grid>
                        </Grid>
                    </MDBox>
                </Card>
            </MDBox>
        </Modal>
    }

    const renderBulkEmailModal = () => {
        return <Modal open={showBulkEmailModal} color={"warning"}
            onClose={() => { setShowBulkEmailModal(false) }}>
            <MDBox sx={{ ...modalStyle, width: "720px", maxWidth: "95vw" }}>
                <Card id="bulk-email" sx={{ overflow: "visible" }}>
                    <MDBox p={3} pb={2}>
                        <MDTypography variant="h6">Send Email To Selected Staff ({selectedRecipientCount})</MDTypography>
                        {selectedRecipientEmails.length > 0 && (
                            <Tooltip
                                placement="bottom-start"
                                title={<span style={{ whiteSpace: "pre-line" }}>{selectedRecipientTooltip}</span>}
                            >
                                <MDTypography variant="caption" color="text" sx={{ cursor: "default" }}>
                                    {selectedRecipientPreview}
                                </MDTypography>
                            </Tooltip>
                        )}
                    </MDBox>
                    <MDBox pb={3} px={3}>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <TextField
                                    fullWidth
                                    required
                                    label="Subject"
                                    value={bulkEmailSubject}
                                    onChange={(event) => setBulkEmailSubject(event.target.value)}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <MDBox sx={{
                                    "& .ql-container": { minHeight: "260px" },
                                    "& .ql-editor": { minHeight: "260px" },
                                }}>
                                    <MDEditor
                                        value={bulkEmailBody}
                                        onChange={setBulkEmailBody}
                                        modules={{
                                            toolbar: [
                                                ["bold", "italic", "underline"],
                                                [{ header: [1, 2, 3, 4, 5, 6, false] }],
                                                [{ list: "bullet" }, { list: "ordered" }],
                                                ["blockquote"],
                                                [{ align: [] }],
                                                ["clean"],
                                            ],
                                        }}
                                    />
                                </MDBox>
                            </Grid>
                            <Grid item xs={12}>
                                <MDButton color="info" size="large" onClick={sendBulkEmail}>Send Email</MDButton>
                            </Grid>
                        </Grid>
                    </MDBox>
                </Card>
            </MDBox>
        </Modal>
    };



    const renderUserList = () => {
        console.log('renderUserList')
        return (
            <MDBox my={3}>
                {renderChangePasswordModel()}
                {renderChangeUnits()}
                {renderBulkEmailModal()}
                <SnackShower values={snackBarSetting} setValues={setSnackBarSetting} />
                <DialogShower values={dialogSetting} setValues={setDialogSetting} />
                <TableShower
                    values={{
                        ...tableSetting,
                        toolbarActions: renderBulkEmailButton(),
                        bulkEmail: {
                            selectedRecipients,
                            onToggleRecipient: toggleRecipient,
                        },
                    }}
                    setValues={setTableSetting}
                />
                {/*{renderTable()}*/}
                <InsertUserComponent settings={userInsertSetting} setSettings={setUserInsertSetting}
                    snackBarSetting={snackBarSetting} setSnackBarSetting={setSnackBarSetting} />
            </MDBox>
        )
    };

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <LoadingOverlay active={activeLoading} spinner text='Loading...'>
                {renderUserList()}
            </LoadingOverlay>
            <Footer />
        </DashboardLayout>
    );
}

export default Staffs;
